<template>
    <Layout>
    <section class="section">
		<div class="container">
			<div class="important-deadlines">
				<h2>Important Deadlines</h2>

				<div class="row">
					<ul class="deadlines">
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn">
							<img class="icon" src="/assets/img/icons/new-user.svg" alt="" width="50">
							<h6>Registration</h6>
							<p>10 January 2020</p>
						</li>
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn" data-delay="100">
							<img class="icon" src="/assets/img/icons/airplane.svg" alt="" width="50">
							<h6>Flight Information</h6>
							<p>30 January 2020</p>
						</li>
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn" data-delay="200">
							<span class="icon section-icon icon-graphic-design-06"></span>
							<h6>High Resolution Logo ( presenting companies): </h6>
							<p>30 January 2020</p>
						</li>
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn">
							<span class="icon section-icon icon-office-06"></span>
							<h6>A/V Form</h6>
							<p>30 January 2020</p>
						</li>
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn" data-delay="100">
							<span class="icon section-icon icon-seo-icons-05"></span>
							<h6>Presentation</h6>
							<p>20 February 2020</p>
						</li>
						<li class="deadline col-sm-4 animated icon-box" data-animation="fadeIn" data-delay="200">
							<span class="icon section-icon icon-shopping-25"></span>
							<h6>Shipping Form</h6>
							<p>20 February 2020</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>

	<section class="section gray-clr-bg">
		<div class="container">
			<div class="row">
				<div class="col-md-12 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/time-zone.jpg')">
						<h5 class="interactive-box__heading">Extended Format</h5>
						<div class="interactive-box__content">
							<p>Due to both the large number of companies scheduled to attend and strong investor demand for meetings with presenting companies, we have decided to switch to a four-day conference format. Presenting companies will be scheduled to attend either 2-3 March or 4-5 March 2020. EFG Hermes will mark you as available for the 4 days. If you have any flight/time constraints, please edit your registration form and uncheck the boxes with the times when you are not available.</p>

							<p>Please visit your registration form to update your available time slots or contact <a href="mailto:VirtualConference@EFGHERMES.com">VirtualConference@EFGHERMES.com</a></p>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/visa.jpg')">
						<h5 class="interactive-box__heading">Visas</h5>
						<div class="interactive-box__content">
							<p>Visas to the UAE may be obtained through Emirates Airlines or Atlantis, The Palm hotel. For terms and conditions for obtaining the visa through the hotel, please consult this form, as well as the hotel visa application form and credit card authorization form.</p>

							<p>Citizens of the GCC nations of Bahrain, Kuwait, Oman, Qatar and Saudi Arabia do not require a visa to travel to the UAE.</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/dress-code.jpg')">
						<h5 class="interactive-box__heading">Dress Code</h5>
						<div class="interactive-box__content">
							<p>Formal business attire is appropriate throughout the conference. A light sweater or jacket may be appropriate in the evening when the weather is cooler.</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/climate.jpg')">
						<h5 class="interactive-box__heading">Climate</h5>
						<div class="interactive-box__content">
							<p>The average temperature in Dubai in March is 26 Celsius (79 Fahrenheit), with highs of 29 Celsius (84 Fahrenheit) and lows of 23 (73 Fahrenheit) in the evenings. Precipitation is rare.</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/language.jpg')">
						<h5 class="interactive-box__heading">Language</h5>
						<div class="interactive-box__content">
							<p>The official language of the meetings is English.</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/time-zone.jpg')">
						<h5 class="interactive-box__heading">Time Zone</h5>
						<div class="interactive-box__content">
							<p>Dubai is four hours ahead of Greenwich Mean Time.</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30">
					<div data-mh="interactive-box" class="interactive-box dark" style="background-image: url('./assets/img/backgrounds/contact-us.jpg')">
						<h5 class="interactive-box__heading">Contact Information</h5>
						<div class="interactive-box__content">
							<p><a href="mailto:VirtualConference@EFGHERMES.com">VirtualConference@EFGHERMES.com</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section">
		<div class="container">
			<div class="no-free-will">
				<div class="row">
					<div class="bottom-links">
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Participation Guidelines (Presenters)</a>
						</div>
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Brochure (Investors)</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    </Layout>
</template>

<script>

import Layout from '@/components/layouts/Layout.vue'

export default {
  name: 'UsefulInformation',
  components: {Layout}
};
</script>
